import React, { Component } from 'react';
import '../myutils';
import {
    translate,
} from 'react-admin'; 
import BookIcon from '@material-ui/icons/Book'; 
import IconButton from '@material-ui/core/IconButton';
import ContentCopy from '@material-ui/icons/ContentCopy';
import { Tooltip } from '@material-ui/core';


export const TemplateIcon = BookIcon;

class CopyFile extends Component {

    state = {
        open: false,
    };
    constructor(props) {
        super(props);
        this.state = {
            record: false
        }

    }

    handleClickCopy = (e, record) => {
        e.stopPropagation();
        if (this.props.handleCloseMenu) this.props.handleCloseMenu();
        sessionStorage.setItem('action', 'copy')
        if (record) {
            sessionStorage.setItem('copiedFile', record.what)
        }
        else {
            sessionStorage.setItem('copiedFile', sessionStorage.selectedFile)
        }
    };

    render() {
        const { translate } = this.props;
        return (
            <Tooltip title={translate(`trans.copy`)}>
                <IconButton onClick={(e) => this.handleClickCopy(e, this.props.record)}>
                    <ContentCopy/>
                </IconButton>
            </Tooltip>
        );
    }
}


export default translate(CopyFile);
